import { useHistory } from 'react-router';

//components
import { SplitButton } from 'primereact/splitbutton';
import { Column } from 'primereact/column';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { TreeTable } from 'primereact/treetable';
import { TreeTableCard } from './styled';

//utils
import { FaEllipsisH } from 'react-icons/fa';
import handleLongText from '../../../../utils/handleLongText/handleLongText';
import { useEffect, useState } from 'react';

export function DisciplinesTable(props: any) {
    const history = useHistory();
    const { nodes, treeFields, onExpand, loading, handleRemoveDiscipline, className } = props;

    useEffect(() => {
        console.log(nodes);
    }, [nodes])

    function nameTemplate(node: any) {
        return (
            <span className="mb-0">{handleLongText(node.data?.title, 32)}</span>
        );
    }

    function actionsTemplate(node: any) {
        let items: any = []

        items.push({
            label: <span>Visualizar</span>,
            command: () => {
                history.push('/manager/material/discipline/' + node.data.discipline_id);
            }
        })

        items.push({
            label: <span>Excluir</span>,
            command: () => {
                handleRemoveDiscipline(node)
            }
        })

        return (
            <>
                {
                    node.data?.type && node.data.type === "Discipline" &&
                    <OverlayTrigger placement="top" overlay={<Tooltip>Opções</Tooltip>}>
                        <div>
                            <SplitButton
                                label=""
                                className="p-button p-component p-button-rounded p-button-text p-button-icon-only"
                                buttonClassName="d-none"
                                dropdownIcon={<FaEllipsisH />}
                                model={items}
                            />
                        </div>
                    </OverlayTrigger>
                }

                {
                    node.data?.icon &&
                    <div>
                        {node.data?.icon ? (
                            <em className={`material-icons-${node.data?.icon}`} style={{verticalAlign: 'middle', color:"#606060" }}>{node.data?.icon.split(' ')[1]}</em>
                        ) : (
                            <em className="material-icons-outlined sticky_note_2" style={{verticalAlign: 'middle', color:"#606060"}}>sticky_note_2</em>
                        )}
                    </div>
                }
            </>
        );
    }

    return (
        <div>
            <TreeTableCard>
                <TreeTable value={nodes} autoLayout expandedKeys={{}} className={className}
                    onExpand={onExpand} loading={loading}>
                    {!!treeFields?.length && treeFields?.map((col: any, index: any) => {
                        if (col.actionsTemplate) {
                            return <Column key={col.field} body={actionsTemplate} field={col.field} header={col.header} style={col.style} {...col} />;
                        } else if (col.nameTemplate) {
                            return <Column expander key={index} body={nameTemplate} field={col.field} header={col.header} style={col.style} {...col} />;
                        } else {
                            return <Column key={col.field} field={col.field} header={col.header} style={col.style} {...col} />;
                        }
                    })}
                    {props.children}
                </TreeTable>
            </TreeTableCard>
        </div>
    );

}